if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.ensureVariantGallerySliderWrapper();
			this.galleryItemsContainer = this.getGalleryItemsContainer();
			this.galleryThumbnailsHolder = this.querySelector('.product-gallery__thumbnails-holder');
			this.variantImagesMap = this.getVariantImagesMap();
			this.defaultGalleryItemsMarkup = this.galleryItemsContainer ? this.galleryItemsContainer.innerHTML : '';
			this.defaultThumbnailsMarkup = this.galleryThumbnailsHolder ? this.galleryThumbnailsHolder.innerHTML : '';
			this.defaultGalleryItemStyle = this.galleryItemsContainer && this.galleryItemsContainer.querySelector('.product-gallery-item')
				? this.galleryItemsContainer.querySelector('.product-gallery-item').getAttribute('style') || 'padding-top: 100%'
				: 'padding-top: 100%';
			this.enableZoomInVariantGallery = Boolean(this.galleryItemsContainer?.querySelector('product-image-zoom'));
			this.zoomIconMarkup = this.galleryItemsContainer?.querySelector('product-image-zoom')?.innerHTML?.trim()
				|| '<svg aria-hidden="true" focusable="false" class="icon icon-zoom-in" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/><path d="M12.5 12.5L17 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8 5.5V10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M5.5 8H10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
			this.isUsingVariantImagesGallery = false;

			// Gallery thumbnails

			if ( this.galleryThumbnailsHolder ) {
				this.galleryThumbnailsHolder.addEventListener('click', this.onThumbnailClick.bind(this));
			}

			if ( this.productSlider ) {

				this.thumbnailNavigationHelper(0);

				this.productSlider.addEventListener('change', e=>{
					this.thumbnailNavigationHelper(e.target.index);

					const activeSlide = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
					if ( activeSlide && activeSlide.dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', activeSlide.dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		getGalleryItemsContainer(){
			if ( this.productSlider ) {
				return this.productSlider.querySelector('.grid');
			}
			if ( this.productGallery ) {
				return this.productGallery.querySelector('.grid');
			}
			return null;
		}

		ensureVariantGallerySliderWrapper(){
			if ( !this.productGallery || this.productSlider ) return;
			if ( this.productGallery.dataset.hasVariantImagesJson !== 'true' ) return;
			if ( !this.productGallery.classList.contains('product-gallery--slider') ) return;

			const galleryGrid = this.productGallery.querySelector('.grid');
			if ( !galleryGrid || galleryGrid.closest('css-slider') ) return;

			const sliderOptions = {
				selector: '.product-gallery-item',
				autoHeight: true,
				thumbnails: false,
				navigation: true,
				navigationDOM: '<span class="css-slider-button css-slider-prev" style="display:none"><svg fill="none" height="13" viewBox="0 0 8 13" width="8" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m7.91419 1.41431-6.48529 6.48528-1.4142102-1.41422 6.4852802-6.48527702z"/><path d="m6.48528 12.9849-6.48528027-6.48532 1.41421027-1.41421 6.48528 6.48523z"/></g></svg></span><span class="css-slider-button css-slider-next" style="display:none"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.914169 11.5857L7.39945 5.10041L8.81367 6.51463L2.32838 12.9999L0.914169 11.5857Z" fill="black"/><path d="M2.34307 0.0151367L8.82835 6.50042L7.41414 7.91463L0.928857 1.42935L2.34307 0.0151367Z" fill="black"/></svg></span>',
				listenScroll: true
			};

			const slider = document.createElement('css-slider');
			slider.className = 'css-slider--bottom-navigation element--border-radius';
			slider.id = `css-slider-${this.id || 'variant-gallery'}`;
			slider.dataset.options = JSON.stringify(sliderOptions);

			galleryGrid.parentNode.insertBefore(slider, galleryGrid);
			slider.appendChild(galleryGrid);
			this.productSlider = slider;
		}

		onThumbnailClick(e){
			const thumbnail = e.target.closest('.thumbnail');
			if ( !thumbnail || !this.galleryThumbnailsHolder || !this.productGallery ) return;

			const targetIndex = thumbnail.dataset.index;
			if ( targetIndex == null ) return;

			if ( this.productSlider && this.productSlider.sliderEnabled ) {
				this.productSlider.changeSlide(targetIndex);
			} else {
				const targetSlide = this.productGallery.querySelector(`.product-gallery-item[data-index="${targetIndex}"]`);
				if ( targetSlide ) {
					window.scrollTo({
						top: targetSlide.offsetTop + this.offsetTop,
						behavior: 'smooth'
					});
				}
				this.thumbnailNavigationHelper(targetIndex);
			}

			this.galleryThumbnailsHolder.scrollTo({
				left: thumbnail.offsetLeft - 50,
				behaviour: 'smooth'
			});
		}

		getVariantImagesMap(){
			if ( !this.productGallery ) return null;
			const mapElement = this.productGallery.querySelector('[data-js-variant-images-json-map]');
			if ( !mapElement ) return null;
			try {
				return JSON.parse(mapElement.textContent);
			} catch (error) {
				console.warn('Unable to parse variant images map', error);
				return null;
			}
		}

		getVariantImagesByVariantId(variantId){
			if ( !this.variantImagesMap || !variantId ) return [];
			const variantImages = this.variantImagesMap[String(variantId)];
			if ( !Array.isArray(variantImages) ) return [];

			const normalizedImages = variantImages
				.filter(image => image && typeof image.url === 'string' && image.url.trim() !== '')
				.map(image => ({
					url: image.url.trim(),
					main: Boolean(image.main)
				}));

			if ( normalizedImages.length < 2 ) return normalizedImages;

			const mainImages = normalizedImages.filter(image => image.main);
			if ( mainImages.length === 0 ) return normalizedImages;

			const secondaryImages = normalizedImages.filter(image => !image.main);
			return [...mainImages, ...secondaryImages];
		}

		renderVariantImagesGallery(variant){
			if ( !variant ) return false;

			const variantImages = this.getVariantImagesByVariantId(variant.id);
			if ( !variantImages.length ) return false;

			this.galleryItemsContainer = this.getGalleryItemsContainer();
			if ( !this.galleryItemsContainer ) return false;

			this.galleryItemsContainer.innerHTML = variantImages
				.map((image, index) => this.buildVariantGalleryItemMarkup(image, index, variant))
				.join('');

			if ( this.galleryThumbnailsHolder ) {
				this.galleryThumbnailsHolder.innerHTML = variantImages
					.map((image, index) => this.buildVariantThumbnailMarkup(image, index, variant))
					.join('');
			}

			this.isUsingVariantImagesGallery = true;
			this.resetGallerySlider();
			this.thumbnailNavigationHelper(0);

			return true;
		}

		restoreDefaultGallery(){
			if ( !this.isUsingVariantImagesGallery ) return;

			this.galleryItemsContainer = this.getGalleryItemsContainer();
			if ( this.galleryItemsContainer ) {
				this.galleryItemsContainer.innerHTML = this.defaultGalleryItemsMarkup;
			}
			if ( this.galleryThumbnailsHolder ) {
				this.galleryThumbnailsHolder.innerHTML = this.defaultThumbnailsMarkup;
			}

			this.isUsingVariantImagesGallery = false;
			this.resetGallerySlider();
			this.thumbnailNavigationHelper(0);
		}

		resetGallerySlider(){
			if ( !this.productSlider ) return;

			if ( this.productSlider.sliderEnabled ) {
				this.productSlider.destroySlider();
			}
			this.productSlider.initSlider();
		}

		buildVariantGalleryItemMarkup(image, index, variant){
			const mediaId = `variant-${variant.id}-${index}`;
			const altText = this.escapeHtml(`${variant.title} - ${index + 1}`);
			const imageUrl = this.escapeHtml(image.url);
			const zoomMarkup = this.enableZoomInVariantGallery
				? `<product-image-zoom class="product-gallery-item__zoom" data-image="${imageUrl}" aria-hidden="true" tabindex="-1">${this.zoomIconMarkup}</product-image-zoom>`
				: '';
			return `
				<div
					id="FeaturedMedia-${this.id}-${mediaId}"
					class="product-gallery-item element--border-radius element--border-radius"
					data-product-media-type="image"
					data-product-single-media-wrapper
					data-media-id="${mediaId}"
					data-video
					tabindex="0"
					data-index="${index}"
					${this.enableZoomInVariantGallery ? 'data-image-zoom' : ''}
					style="${this.defaultGalleryItemStyle}"
				>
					<div class="product-gallery-item__media lazyloaded">
						<img
							src="${imageUrl}"
							alt="${altText}"
							class="img apply-gallery-animation"
							loading="lazy"
							style="width: 100%; height: 100%; object-fit: contain;"
						>
					</div>
					${zoomMarkup}
				</div>
			`;
		}

		buildVariantThumbnailMarkup(image, index, variant){
			const imageUrl = this.escapeHtml(image.url);
			const altText = this.escapeHtml(`${variant.title} - ${index + 1}`);
			return `
				<button class="thumbnail element--border-radius" data-index="${index}" tabindex="0">
					<span class="visually-hidden">${index + 1}</span>
					<span aria-hidden="true" style="display:block">
						<figure class="lazy-image lazy-image--small lazyloaded" data-ratio style="padding-top: 75%">
							<img
								src="${imageUrl}"
								alt="${altText}"
								class="thumbnail__image"
								loading="eager"
								style="width: 100%; height: 100%; object-fit: contain; opacity: 1;"
							>
						</figure>
					</span>
				</button>
			`;
		}

		escapeHtml(text){
			return String(text)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;');
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		updateOmnibus(variant){
			const root = this.querySelector('[data-js-omnibus]');
			if ( !root ) return;

			const mapEl = root.querySelector('[data-js-omnibus-map]');
			const contentEl = root.querySelector('[data-js-omnibus-content]');
			if ( !mapEl || !contentEl ) return;

			let map = null;
			try {
				map = JSON.parse(mapEl.textContent);
			} catch (error) {
				console.warn('Unable to parse omnibus price map', error);
				return;
			}

			if ( !variant || !map ) {
				contentEl.innerHTML = '';
				return;
			}

			const price = map[String(variant.id)];
			if ( !price ) {
				contentEl.innerHTML = '';
				return;
			}

			const label = root.dataset.omnibusLabel || '';
			const labelHtml = label
				? `<span class="product-omnibus__label">${this.escapeHtml(label)}:</span> `
				: '';
			contentEl.innerHTML = `<div class="product-omnibus text-size--small">${labelHtml}<span class="product-omnibus__value">${this.escapeHtml(price)}</span></div>`;
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			this.updateOmnibus(variant);
			if ( !variant ) {
				this.restoreDefaultGallery();
				return;
			}

			const hasVariantSpecificGallery = this.renderVariantImagesGallery(variant);
			if ( !hasVariantSpecificGallery ) {
				this.restoreDefaultGallery();
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}
			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}